<ng-container
  [ngTemplateOutlet]="!event ? templateEmpty : templateDetail"
></ng-container>

<ng-template #templateEmpty>
  <span>{{ '$lbl.notRawData' | translate }}</span>
</ng-template>

<ng-template #templateDetail>
  <div class="row box-standard-padding">
    <div class="col-6 form-group"><span class="bold">{{ '$lbl.id' | translate }}:</span></div>
    <div class="col-6">{{ event?.id }}</div>
  
    <div class="col-6 form-group"><span class="bold">{{ 'vocabulary.TimeLine.Date' | translate }}:</span></div>
    <div class="col-6">{{ event?.timestamp | date: constantHelper.DATE_TIME_FORMAT }}</div>
  
    <div class="col-6 form-group"><span class="bold">{{ '$lbl.service' | translate }}:</span></div>
    <div class="col-6">{{ event?.service }}</div>
  
    <div class="col-6 form-group"><span class="bold">{{ 'vocabulary.Dumpster.Supplier' | translate }}:</span></div>
    <div class="col-6">{{ event?.supplier }}</div>
  
    <div class="col-6 form-group"><span class="bold">{{ 'common.Type' | translate }}:</span></div>
    <div class="col-6">{{ event?.payloadType | payloadType: payloadTypes }}</div>
  
    <div class="col-6 form-group"><span class="bold">{{ '$lbl.version' | translate }}:</span></div>
    <div class="col-6">{{ event?.version }}</div>
    
    <div class="col-4 mb-2">
      <button
        type="button"
        class="btn btn-primary mt-2 mr-2"
        (click)="setCopy()"
      >
        <i class="fas fa-download"></i>
        {{ '$lbl.copy' | translate }}
      </button>
      <button
        type="button"
        class="btn btn-primary mt-2"
        (click)="downloadFile()"
      >
        <i class="fas fa-file-export"></i>
        {{ 'page.DumpsterDetail.Event.Export.Action' | translate }}
      </button>
    </div>
    <pre class="col-12" variant="pre"><code variant="code" language="json">{{ event | jsonMap | json }}</code></pre>
  </div>
</ng-template>
